import React from 'react'
import Newsletter from './Newsletter/Newsletter'
import Links from './Links/Links'

const Footer = props => {
    return (
        <>
            <Newsletter />
            <Links />
        </>
    )
}

export default Footer
